export default __webpack_public_path__ + "static/media/drag_n_drop_kr.7707e4f1.gif";